import { motion } from "framer-motion";

import ImageContainer from "../../components/ImageContainer";

import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import {
  BookOpen,
  Users,
  Lightbulb,
  Award,
  TrendingUp,
  Sparkles,
  Leaf,
  Compass,
  ShieldCheck,
  Info,
} from "lucide-react";
import BlockImageCabecera from "../../components/BlockImageCabecera";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/0014d852-bb1b-419f-a0ae-011eee26820f" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_imagen3.field_media_image " +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen3" +
  "&fields[media--image]=field_media_image";

function GestionProcesos() {
  const [activeTab, setActiveTab] = useState("carrera"); // 'carrera' | 'institucionales'

  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      ></BlockImageCabecera>

      <section className="max-w-6xl px-6 sm:px-0 m-auto py-16">
        <div
          className="link-with-arrow-1"
          dangerouslySetInnerHTML={{
            __html: data.bloque1,
          }}
        />
      </section>

      <section className="bluebg py-16">
        <div className="max-w-6xl px-6 sm:px-0 m-auto">
          <div
            className="link-with-arrow-1"
            dangerouslySetInnerHTML={{
              __html: data.bloque2,
            }}
          />
        </div>
      </section>

      <section className=" py-16">
        <div className="max-w-6xl px-6 sm:px-0 m-auto">
          <div
            className="link-with-arrow-1"
            dangerouslySetInnerHTML={{
              __html: data.bloque3,
            }}
          />

          <div className="max-w-3xl m-auto mb-10">
            <img src={data.imagen3}></img>{" "}
          </div>
        </div>
      </section>

      
      <section className="bg-slate-50 py-16">
        <div className="max-w-6xl px-6 sm:px-0 m-auto">
          <div
            className="link-with-arrow-1"
            dangerouslySetInnerHTML={{
              __html: data.bloque4,
            }}
          />

       
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default GestionProcesos;
